import React, { Fragment, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useProductsAdmin from '../../../../../Hooks/ProductsAdmin'
import Form from '../../../../Common/Form'
import InputButton from '../../../../Common/InputButton'
import InputItem from '../../../../Common/InputItem'
import SelectCategory from '../../../../Common/SelectCategory'

function EditeProduct() {
    const Location = useLocation()
    const [category_id, setCategory_id] = useState();
    const [previews, setPreviewImage] = useState(Location?.state?.images);
    const setPreviews = (e, i = '-1') => {
        if (i == '-1') {
            setPreviewImage([...previews, e.target.files[0]])
        } else {
            let newImages = [...previews].filter((v, x) => x != i);;
            newImages.push(e.target.files[0])
            setPreviewImage(newImages)
        }
    }
    useEffect(() => {
        window.document.getElementById('title-page').innerHTML = "ویرایش  محصول"
    }, []);
    const { addProduct, loadingBtn } = useProductsAdmin(true)
    const [oldimages, setoldimages] = useState(Location?.state?.images || [])
    return (
        <Form submit={addProduct}>
            <input type="hidden" value={Location?.state?.id} name="id" />
            {oldimages.map((img) => {
                return <input type="hidden" value={img} name="oldimages[]" />
            })}

            <div className="card-body row">
                <div className="form-group my-3 col-lg-4 ">
                    <label htmlFor="name">نام محصول</label>
                    <input defaultValue={Location?.state?.name} type="text" id="name" name='name' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-4 ">
                    <label htmlFor="name_en">نام محصول لاتین</label>
                    <input defaultValue={Location?.state?.name_en} type="text" id="name_en" name='name_en' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-4 ">
                    <label htmlFor="qr_code">کد محصول</label>
                    <input defaultValue={Location?.state?.qr_code} type="text" id="qr_code" name='qr_code' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-4 ">
                    <label htmlFor="price">قیمت محصول</label>
                    <input defaultValue={Location?.state?.price} type="text" id="price" name='price' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-4 ">
                    <label htmlFor="discount">تخفیف</label>
                    <input defaultValue={Location?.state?.discount} type="text" id="discount" name='discount' className='form-control' />
                </div>
                <SelectCategory value={category_id ? category_id : Location?.state?.category_id} onChange={({ target: { value } }) => {
                    setCategory_id(value)
                }} name="category_id" className="my-3 col-lg-4" />
                <InputItem name="config" label='راه اندازی محصول' defaultValue={Location?.state?.config} itemClassName="col-md-6" />
                <div className="form-group my-3 col-lg-6 ">
                    <label htmlFor="name">موجود در انبار</label>
                    <div className='mt-3'>
                        <label htmlFor="has" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.stock == "1" && "checked"} type="radio" value={1} id="has" name='stock' />
                            <span className='mx-1'> موجود</span>
                        </label>
                        <label htmlFor="no" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.stock == "0" && "checked"} type="radio" value={0} id="no" name='stock' />
                            <span className='mx-1'>ناموجود</span>
                        </label>
                    </div>
                </div>
                <div className="form-group my-3 col-lg-6 ">
                    <label htmlFor="name">نمایش محصول</label>
                    <div className='mt-3'>
                        <label htmlFor="show" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.status == "1" && "checked"} type="radio" value={1} id="show" name='status' />
                            <span className='mx-1'> نمایش داده شود</span>
                        </label>
                        <label htmlFor="noShow" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.status == "0" && "checked"} type="radio" value={0} id="noShow" name='status' />
                            <span className='mx-1'>  مخفی</span>
                        </label>
                    </div>
                </div>
                <div className="form-group my-3 col-lg-6 ">
                    <label htmlFor="name">محصول ویژه</label>
                    <div className='mt-3'>
                        <label htmlFor="featured" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.featured == "1" && "checked"} type="radio" value={1} id="featured" name='featured' />
                            <span className='mx-1'>  ویژه</span>
                        </label>
                        <label htmlFor="nofeatured" className='me-3 d-flex'>
                            <input defaultChecked={Location?.state?.featured == "0" && "checked"} type="radio" value={0} id="nofeatured" name='featured' />
                            <span className='mx-1'>  غیر ویژه</span>
                        </label>
                    </div>
                </div>
                <div className="form-group my-3 col-lg-12 ">
                    <label htmlFor="short_description">توضیحات مختصر</label>
                    <input defaultValue={Location?.state?.short_description} type="text" id="short_description" name='short_description' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-12 ">
                    <label htmlFor="description">توضیحات کامل</label>
                    <input defaultValue={Location?.state?.description} type="text" id="description" name='description' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-6 ">
                    <label htmlFor="seo[title]">{`عنوان (سئو)`}</label>
                    <input defaultValue={Location?.state?.seo.title} type="text" id="seo[title]" name='seo[title]' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-6 ">
                    <label htmlFor="seo[keywords]">{`کلمات کلیدی (سئو)`}</label>
                    <input defaultValue={Location?.state?.seo.keywords} type="text" id="seo[keywords]" name='seo[keywords]' className='form-control' />
                </div>
                <div className="form-group my-3 col-lg-12 ">
                    <label htmlFor="seo[description]">{`توضیحات (سئو)`}</label>
                    <input defaultValue={Location?.state?.seo.description} type="text" id="seo[description]" name='seo[description]' className='form-control' />
                </div>
                <InputItem defaultValue={Location?.state?.meta_data} name="meta_data" label='مشخصات محصول' itemClassName="col-md-6" />
                <div className="form-group">
                    <div className='d-flex align-items-center justify-content-between'>
                        <label htmlFor="short_description">تصویر محصول</label>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            setPreviews({ target: { files: [''] } })
                        }} className='badge px-4 py-2 bg-primary'>افزودن عکس یا فیلم</span>
                    </div>

                    <div className='row align-items-center' >
                        {previews.map((preview, i) => {
                            return (
                                <div className="form-group my-3 col-lg-3" >
                                    <div className='enter-image position-relative' style={{ height: 200 }}>
                                        <input name='images[]' type="file" accept="image/*,video/*" onChange={(e) => {
                                            setPreviews(e, i)
                                        }} />
                                        {typeof preview == 'object' || String(preview).length ?
                                            <Fragment>
                                                <img id='image' style={{ objectFit: "contain" }} src={typeof preview == 'object' ? URL.createObjectURL(preview) : preview} alt="عکس محصول" />
                                                {
                                                    i != 0 ?
                                                        <div style={{ cursor: "pointer", zIndex: 100000 }} onClick={() => {
                                                            setPreviewImage([...previews].filter((v, x) => x != i))
                                                            setoldimages([...oldimages].filter((v, y) => y != i))
                                                        }} className="add-logo bob">
                                                            x
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </Fragment>
                                            :
                                            <div className="add-logo">
                                                <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path d="M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z" />
                                                </svg>
                                            </div>
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="col-12">
                    <InputButton label='ویرایش محصول' loading={loadingBtn} />
                </div>
            </div>
        </Form>
    )
}

export default EditeProduct